import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Search, FileText, Eye, Download, Printer } from "lucide-react";
import { motion } from "framer-motion";

const invoices = [
  { id: "INV-0189", order: "ORD-001", customer: "Ahmed Khan", date: "2026-03-28", amount: "₨ 5,350,000", status: "Paid", dueDate: "2026-04-05" },
  { id: "INV-0188", order: "ORD-002", customer: "Muhammad Ali", date: "2026-03-27", amount: "₨ 6,900,000", status: "Partial", dueDate: "2026-04-10" },
  { id: "INV-0187", order: "ORD-003", customer: "Hassan Raza", date: "2026-03-25", amount: "₨ 8,600,000", status: "Unpaid", dueDate: "2026-04-01" },
  { id: "INV-0186", order: "ORD-004", customer: "Usman Sheikh", date: "2026-03-24", amount: "₨ 9,300,000", status: "Paid", dueDate: "2026-03-30" },
  { id: "INV-0185", order: "ORD-005", customer: "Bilal Ahmad", date: "2026-03-22", amount: "₨ 2,950,000", status: "Paid", dueDate: "2026-03-28" },
];

const Invoices = () => {
  return (
    <Layout title="Invoices">
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h1 className="text-2xl font-display font-bold text-foreground">Invoices</h1>
            <p className="text-sm text-muted-foreground mt-1">Generate and manage invoices</p>
          </div>
          <Button variant="premium" className="gap-2"><Plus className="w-4 h-4" /> Create Invoice</Button>
        </div>

        <div className="relative max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input placeholder="Search invoices..." className="glass-input pl-9 h-10" />
        </div>

        <div className="glass-card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border/30">
                  {["Invoice #", "Order", "Customer", "Date", "Due Date", "Amount", "Status", "Actions"].map(h => (
                    <th key={h} className="text-left text-xs font-medium text-muted-foreground px-5 py-3">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {invoices.map((inv, i) => (
                  <motion.tr key={inv.id} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: i * 0.05 }} className="border-b border-border/20 hover:bg-secondary/30 transition-colors">
                    <td className="px-5 py-3.5">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                          <FileText className="w-3.5 h-3.5 text-primary" />
                        </div>
                        <span className="text-sm font-medium text-primary">{inv.id}</span>
                      </div>
                    </td>
                    <td className="px-5 py-3.5 text-sm text-muted-foreground">{inv.order}</td>
                    <td className="px-5 py-3.5 text-sm text-foreground">{inv.customer}</td>
                    <td className="px-5 py-3.5 text-sm text-muted-foreground">{inv.date}</td>
                    <td className="px-5 py-3.5 text-sm text-muted-foreground">{inv.dueDate}</td>
                    <td className="px-5 py-3.5 text-sm font-medium text-foreground">{inv.amount}</td>
                    <td className="px-5 py-3.5">
                      <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${
                        inv.status === "Paid" ? "bg-success/10 text-success" :
                        inv.status === "Partial" ? "bg-warning/10 text-warning" :
                        "bg-destructive/10 text-destructive"
                      }`}>{inv.status}</span>
                    </td>
                    <td className="px-5 py-3.5">
                      <div className="flex items-center gap-1">
                        <Button variant="ghost" size="icon" className="h-7 w-7 text-muted-foreground hover:text-foreground"><Eye className="w-3.5 h-3.5" /></Button>
                        <Button variant="ghost" size="icon" className="h-7 w-7 text-muted-foreground hover:text-foreground"><Download className="w-3.5 h-3.5" /></Button>
                        <Button variant="ghost" size="icon" className="h-7 w-7 text-muted-foreground hover:text-foreground"><Printer className="w-3.5 h-3.5" /></Button>
                      </div>
                    </td>
                  </motion.tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Invoices;
